import type { ExperimentKey, GeometryExperimentDef } from '../types';
import { experiment as angleChaseExp } from './angle-chase';
import { experiment as triangleLabExp } from './triangle-lab';
import { experiment as pythagorasExp } from './pythagoras';
import { experiment as similarityExp } from './similarity';
import { experiment as circleTheoremsExp } from './circle-theorems';
import { experiment as areaLabExp } from './area-lab';
import { experiment as transformationsExp } from './transformations';
import { experiment as coordinateGeometryExp } from './coordinate-geometry';
import { experiment as constructionsExp } from './constructions';

// ============================================================================
// Experiment Registry
// ============================================================================

export const EXPERIMENTS: Record<ExperimentKey, GeometryExperimentDef> = {
  'angle-chase': angleChaseExp,
  'triangle-lab': triangleLabExp,
  pythagoras: pythagorasExp,
  similarity: similarityExp,
  'circle-theorems': circleTheoremsExp,
  'area-lab': areaLabExp,
  transformations: transformationsExp,
  'coordinate-geometry': coordinateGeometryExp,
  constructions: constructionsExp,
};

/**
 * Curriculum order: foundation concepts → advanced.
 */
export const EXPERIMENT_ORDER: ExperimentKey[] = [
  'angle-chase',
  'triangle-lab',
  'pythagoras',
  'similarity',
  'circle-theorems',
  'area-lab',
  'transformations',
  'coordinate-geometry',
  'constructions',
];
